import React from 'react'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'

const MemberSubTypeToolTip = () => (
    <CustomToolTip
        type="?"
        info="Mechanical royalties result from a mechanical license, which is permission to reproduce and distribute a musical work in the form of a physical or digital phonorecord. Examples of this include streaming a musical work on a platform such as Spotify or Apple Music."
    />
)

export default MemberSubTypeToolTip
